module.exports = __webpack_public_path__ + "static/media/card_tube_snails.f5895eec.jpg";